const upgradePersonal = {
  bannerTitle: 'HitPaw Online Ultimate',
  introduct:
    'Accede a más de 35 herramientas premium en toda la suite, incluyendo Enhancer, Remover, AI translater, Screen Recorder y más. Disponibles a un precio económico.',
  Upgrade: 'Actualizar',
  Tools: 'Herramientas',
  MyProjects: 'Mis Proyectos',
  MyAccount: 'Mi Cuenta',
  Subscription: 'Suscripción',
  LogOut: 'Cerrar Sesión',
  PopularTools: 'Herramientas Populares',
  Enhance: 'Mejorar',
  Remove: 'Eliminar',
  Animate: 'Animar',
  Extract: 'Extraer',
  SaveThreeDays:
    'Los proyectos se almacenan durante 3 días, por favor descárguelos después de procesarlos.',
  All: 'Todo',
  Video: 'Vídeo',
  Image: 'Imagen',
  Audio: 'Audio',
  minutesAgo: 'hace minutos',
  hoursAgo: 'hace horas',
  daysAgo: 'hace días',
  Modified: 'Modificado',
  Order: 'Orden',
  EarliestToLatest: 'Más Antiguo a Más Reciente',
  LatestToEarliest: 'Más Reciente a Más Antiguo',
  NoProject: 'Aún no hay proyecto. Iniciar rápidam ente con',
  OnlineTools: 'Herramientas Online',
  AIVideoEnhancer: 'AI Video Enhancer',
  Enhancer4K: 'Mejorar vídeos hasta 4K online con un solo clic',
  AIPhotoEnhancer: 'AI Photo Enhancer',
  AIEnhancerImage: 'Mejorar imágenes sin pérdida de IA hasta 8X online',
  View: 'Ver',
  Download: 'Descargar',
  MultipleSelect: 'Selección Múltiple',
  Delete: 'Borrar',
  SubscriptionHistory: 'Historial de Suscripciones',
  NoValidSubscription: 'No hay ninguna suscripción válida.',
  veContent: 'Un clic para mejorar videos con IA hasta 4K en línea',
  peContent: 'AI mejora las imágenes sin pérdidas hasta 8X en línea',
  rmvContent: 'Quitar marca de agua del video',
  rmttContent:
    'Elimina las marcas de agua de los videos de TikTok en un abrir y cerrar de ojos',
  dynamicContent: 'Anima tu foto en línea',
  rmbgContent: 'Quitar el fondo de la imagen',
  youMayNeed: 'Tu puedes necesitar',
  new: 'Nuevo',
  rather: 'Preferiría pagar el precio completo 4.49€/semana.',
  discountPrice: '0.99€ / 7 Días Pro',
  exclDeal: '¡Nueva Oferta Exclusiva!',
  endDeal: '¡Apurarse! El trato termina en',
  loginYourAccount: 'Inicie sesión en su cuenta HitPaw',
  signUpYourAccount: 'Regístrese en su cuenta de HitPaw',
  HitPawWatermark: 'Quitar Marca de Agua de Video',
  HitPawTiktokWatermark: 'Quitar Marca de Agua de TikTok',
  HitPawRemoveBg: 'Eliminador de fondo',
  dynamicTitle: 'HitPaw Animar Fotos Antiguas Online',
};
export default upgradePersonal;
